import React, { Component } from 'react';
import history                    from 'dashboard/history'

export default class Data extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const child = React.Children.only(this.props.children);
    return React.cloneElement(
      child,
      {
        ...child.props,
        availableParseServerVersions: this.props.availableParseServerVersions,
        currentUser: this.props.currentUser,
        currentCustomer: this.props.currentCustomer,
      }
    );
  }
};
